import { createSystem, defaultConfig } from '@chakra-ui/react';
import colors, { alituBrandPurple } from './colors';
import Button from './components/Button';
import Heading from './components/Heading';
import Input from './components/Input';
import Textarea from './components/Textarea';
import NumberInput from './components/NumberInput';
import Field from './components/Field';
import Form from './components/Form';
import Checkbox from './components/Checkbox';
import RadioGroup from './components/RadioGroup';
import Switch from './components/Switch';
import Select from './components/Select';
import Table from './components/Table';
import Link from './components/Link';
import Text from './components/Text';
import Popover from './components/Popover';
import Tooltip from './components/Tooltip';
import Separator from './components/Separator';
import Progress from './components/Progress';
import Slider from './components/Slider';
import fonts from './fonts';
import Dialog from './components/Dialog';
import Alert from './components/Alert';
import Toast from './components/Toast';
import { animations, keyframes } from './animations';
import Tabs from './components/Tabs';

/**
 * Converts {colorName: '#123456',... } to { colorName: { value: '#123456' } } format for Chakra UI theme.
 */
const colorsInChakraFormat = Object.fromEntries(
  Object.entries(colors).map(([key, value]) => [key, { value }]),
);

const system = createSystem(defaultConfig, {
  globalCss: {
    html: {
      // @ts-ignore: WebkitFontSmoothing is not a valid property
      WebkitFontSmoothing: 'auto',
      MozOsxFontSmoothing: 'auto',
      height: '100%',
      overflow: 'hidden',
    },
    body: {
      height: '100%',
      overflowX: 'hidden',
      margin: 0,
    },
    '#app': {
      position: 'absolute',
      inset: 0,
      minH: '640px',
    },
    ul: {
      listStyleType: 'none',
    },
    b: {
      fontFamily: fonts.bold,
    },
  },
  theme: {
    keyframes,
    breakpoints: {
      sm: '400px',
      md: '576px',
      lg: '768px',
      xl: '1100px',
      '2xl': '1390px',
      '3xl': '1500px',
    },
    tokens: {
      animations,
      fonts: {
        heading: { value: fonts.normal },
        body: { value: fonts.normal },
      },
      colors: colorsInChakraFormat,
    },
    semanticTokens: {
      colors: {
        alituBrandPurple,
      },
    },
    recipes: {
      button: Button,
      textarea: Textarea,
      link: Link,
      heading: Heading,
      input: Input,
      text: Text,
      separator: Separator,
    },
    slotRecipes: {
      alert: Alert,
      checkbox: Checkbox,
      dialog: Dialog,
      field: Field,
      form: Form,
      numberInput: NumberInput,
      popover: Popover,
      progress: Progress,
      radioGroup: RadioGroup,
      nativeSelect: Select,
      slider: Slider,
      switch: Switch,
      table: Table,
      tabs: Tabs,
      toast: Toast,
      tooltip: Tooltip,
    },
  },
});

export default system;
